/**
 * /iso-creator orchestrator.
 *
 * Folder/file picker → IsoBuilder → streaming output via FSA showSaveFilePicker.
 */
(function (w) {
    'use strict';
    var DI = w.__DiskImage;
    var I18N = w.IsoCreatorI18n || {};
    var ae = function (n, p) { try { if (typeof w.__ae === 'function') w.__ae(n, p || {}); } catch (_) {} };
    var toast = function (m, k) { if (typeof w.__toast === 'function') w.__toast(m, k); else console.log(m); };
    var handleErr = function (e, c) { if (typeof w.__handleError === 'function') w.__handleError(e, c); else console.error(e); };
    var t = function (k, fb) { return I18N[k] || fb || k; };
    var fill = function (s, vars) { return String(s).replace(/:(\w+)/g, function (m, k) { return vars[k] != null ? vars[k] : m; }); };

    function _human(n) {
        if (n < 1024) return n + ' B';
        if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
        if (n < 1024 * 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + ' MB';
        return (n / 1024 / 1024 / 1024).toFixed(2) + ' GB';
    }

    function App(root) {
        this.root = root;
        this.entries = []; // [{ path, file }]
        this.bootImage = null;
        this.dom = {};
    }

    App.prototype.boot = function () {
        this._cacheDom();
        this._wire();
        this._restoreSettings();
    };

    App.prototype._cacheDom = function () {
        var r = this.root;
        this.dom.btnFolder = r.querySelector('.icr-btn-folder');
        this.dom.btnFiles = r.querySelector('.icr-btn-files');
        this.dom.btnBoot = r.querySelector('.icr-btn-boot');
        this.dom.btnBuild = r.querySelector('.icr-btn-build');
        this.dom.btnReset = r.querySelector('.icr-btn-reset');
        this.dom.list = r.querySelector('.icr-list');
        this.dom.summary = r.querySelector('.icr-summary');
        this.dom.note = r.querySelector('.icr-note');
        this.dom.volumeId = r.querySelector('.icr-volume-id');
        this.dom.publisher = r.querySelector('.icr-publisher');
        this.dom.toggleJoliet = r.querySelector('.icr-toggle-joliet');
        this.dom.toggleUdf = r.querySelector('.icr-toggle-udf');
        this.dom.toggleHybrid = r.querySelector('.icr-toggle-hybrid');
        this.dom.bootInfo = r.querySelector('.icr-boot-info');
        this.dom.progress = r.querySelector('.icr-progress');
        this.dom.progressText = r.querySelector('.icr-progress-text');
    };

    /* The folders in a drop, read SYNCHRONOUSLY (dataTransfer.items is neutered
     * the moment the handler returns), plus the loose files dropped beside them.
     * null when no folder is in it — then the shared zone takes the files. Same
     * shape as the layout's __folderDrop.snapshot, which is what the page-level
     * rescue hands to __acceptDroppedTree. */
    function _snapshot(dt) {
        var items = dt && dt.items ? Array.prototype.slice.call(dt.items) : [];
        var dirs = [], loose = [];
        items.forEach(function (it) {
            if (it.kind !== 'file') return;
            var ent = it.webkitGetAsEntry ? it.webkitGetAsEntry() : null;
            if (ent && ent.isDirectory) dirs.push(ent);
            else { var f = it.getAsFile && it.getAsFile(); if (f) loose.push(f); }
        });
        return dirs.length ? { dirs: dirs, loose: loose } : null;
    }

    App.prototype._wire = function () {
        var self = this;
        var root = this.root;
        var drop = document.getElementById('icrDrop');
        if (drop) {
            drop.addEventListener('tool-uploader:file', function (e) {
                var list = (e.detail && e.detail.files) || (e.detail && e.detail.file ? [e.detail.file] : []);
                self._addEntries(Array.prototype.map.call(list, function (f) {
                    return { path: '/' + (f.webkitRelativePath || f.__relPath || f.name), file: f };
                }), 'zone');
            });
        }
        /* Every drop that carries a folder comes through ONE ingest, wherever it
         * lands. On the tool (zone included): this capture listener — an
         * ancestor's capture runs before the zone's own handler. Anywhere else
         * on the page: the layout's rescue hands the whole snapshot to
         * __acceptDroppedTree. Both used to lose files: the tool took the
         * folders and dropped the loose files beside them on the floor, and the
         * page rescue stopped at 500 files, 8 s and depth 6 and skipped empty
         * files. Plain-file drops onto the zone still go to the zone. */
        w.__acceptDroppedTree = function (snap) { self._ingestSnapshot(snap, 'drop_page'); };
        root.addEventListener('drop', function (e) {
            var snap = _snapshot(e.dataTransfer);
            if (!snap) return;
            e.preventDefault();
            e.stopPropagation();
            self._ingestSnapshot(snap, 'drop_tool');
        }, true);
        root.addEventListener('dragover', function (e) {
            if (e.dataTransfer && e.dataTransfer.types && Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') !== -1) e.preventDefault();
        }, true);
        if (this.dom.btnFolder) this.dom.btnFolder.addEventListener('click', function () { self.pickFolder(); });
        if (this.dom.btnFiles) this.dom.btnFiles.addEventListener('click', function () { self.pickFiles(); });
        if (this.dom.btnBoot) this.dom.btnBoot.addEventListener('click', function () { self.pickBoot(); });
        if (this.dom.btnBuild) this.dom.btnBuild.addEventListener('click', function () { self.build(); });
        if (this.dom.btnReset) this.dom.btnReset.addEventListener('click', function () { self.reset(); });
        ['volumeId', 'publisher'].forEach(function (k) {
            if (self.dom[k] && w.__toolSettings) w.__toolSettings.bind('iso-creator', self.dom[k], k, '');
        });
        ['toggleUdf', 'toggleJoliet'].forEach(function (k) {
            if (self.dom[k]) self.dom[k].addEventListener('change', function () { self._renderSummary(); });
        });
        ['toggleJoliet', 'toggleUdf', 'toggleHybrid'].forEach(function (k) {
            if (self.dom[k] && w.__toolSettings) w.__toolSettings.bind('iso-creator', self.dom[k], k, true);
        });
    };

    App.prototype._restoreSettings = function () {
        if (this.dom.volumeId && !this.dom.volumeId.value) this.dom.volumeId.value = 'TIMBRICA_ISO';
    };

    App.prototype.reset = function () {
        this.entries = [];
        this.bootImage = null;
        this._renderList();
        this._note('');
        if (this.dom.bootInfo) this.dom.bootInfo.textContent = '';
    };

    App.prototype._ingestSnapshot = function (snap, via) {
        var self = this, found = [], failed = { n: 0 };
        var loose = (snap.loose || []).map(function (f) { return { path: '/' + f.name, file: f }; });
        Promise.all(snap.dirs.map(function (ent) { return self._walkDropEntry(ent, '/' + ent.name, found, failed); }))
            .then(function () { self._addEntries(loose.concat(found), via, failed.n); });
    };

    function _freePath(path, taken) {
        var slash = path.lastIndexOf('/'), dir = path.slice(0, slash + 1), name = path.slice(slash + 1);
        var dot = name.lastIndexOf('.'), base = dot > 0 ? name.slice(0, dot) : name, ext = dot > 0 ? name.slice(dot) : '';
        for (var n = 2; ; n++) {
            var cand = dir + base + ' (' + n + ')' + ext;
            if (!taken.has(cand)) return cand;
        }
    }

    /**
     * One entry per ISO path — and a different file never silently replaces one
     * already in the list. It used to: «last add wins», so two cover.jpg dropped
     * from two album folders into the root left one. The same file picked again
     * (same size and date) is skipped; a different one keeps both, the newcomer
     * as «name (2).ext», and the user is told.
     */
    App.prototype._addEntries = function (list, via, unreadable) {
        var byPath = new Map();
        this.entries.forEach(function (e) { byPath.set(e.path, e); });
        var added = 0, same = 0, kept = 0;
        list.forEach(function (e) {
            if (!e || !e.path || !e.file) return;
            var cur = byPath.get(e.path);
            if (cur) {
                if (cur.file === e.file || (cur.file.size === e.file.size && cur.file.lastModified === e.file.lastModified)) { same++; return; }
                e = { path: _freePath(e.path, byPath), file: e.file };
                kept++;
            }
            byPath.set(e.path, e);
            added++;
        });
        this.entries = Array.from(byPath.values());
        ae('feature_use', { slug: 'iso-creator', action: 'iso_create_add', via: via || 'unknown', added: added, same: same, kept_both: kept, unreadable: unreadable || 0, total: this.entries.length });
        if (kept) toast(fill(t('names_kept_both', ':n files had the same name as ones already in the list — both kept, the new ones as «name (2)».'), { n: kept }), 'info');
        if (unreadable) toast(fill(t('unreadable_skipped', ':n items could not be read and were not added.'), { n: unreadable }), 'warning');
        this._renderList();
    };

    App.prototype.pickFolder = function () {
        var self = this;
        if ('showDirectoryPicker' in w) {
            var found = [], failed = { n: 0 };
            w.showDirectoryPicker().then(function (dirHandle) {
                return self._walkFsaDir(dirHandle, '', found, failed);
            }).then(function () {
                self._addEntries(found, 'folder_picker', failed.n);
            }).catch(function (err) { if (err && err.name !== 'AbortError') handleErr(err, 'pick_folder'); });
            return;
        }
        var input = document.createElement('input');
        input.type = 'file';
        input.webkitdirectory = true;
        input.multiple = true;
        input.addEventListener('change', function () {
            self._addEntries(Array.from(input.files || []).map(function (f) {
                return { path: '/' + (f.webkitRelativePath || f.name), file: f };
            }), 'folder_input');
        });
        input.click();
    };

    /* One unreadable file (locked, permission, gone) no longer throws the whole
     * folder away: it is counted and reported, the rest is added. */
    App.prototype._walkFsaDir = function (dirHandle, prefix, out, failed) {
        var self = this;
        var promises = [];
        var iter = dirHandle.values();
        function step() {
            return iter.next().then(function (r) {
                if (r.done) return;
                var entry = r.value;
                var path = prefix + '/' + entry.name;
                if (entry.kind === 'file') {
                    promises.push(entry.getFile().then(function (f) {
                        out.push({ path: path, file: f });
                    }, function () { failed.n++; }));
                } else if (entry.kind === 'directory') {
                    promises.push(self._walkFsaDir(entry, path, out, failed));
                }
                return step();
            }, function () { failed.n++; });
        }
        return step().then(function () { return Promise.all(promises); });
    };

    /* Walk a dropped folder (webkitGetAsEntry tree). readEntries() hands back at
     * most 100 children per call and signals the end with an empty batch, so it
     * has to be looped — reading it once silently loses everything past the
     * hundredth entry. No caps: every file of the folder is the point. */
    App.prototype._walkDropEntry = function (entry, path, out, failed) {
        var self = this;
        return new Promise(function (resolve) {
            if (entry.isFile) {
                entry.file(function (f) { out.push({ path: path, file: f }); resolve(); }, function () { failed.n++; resolve(); });
                return;
            }
            if (!entry.isDirectory) { resolve(); return; }
            var reader = entry.createReader();
            var kids = [];
            var readBatch = function () {
                reader.readEntries(function (batch) {
                    if (!batch.length) {
                        Promise.all(kids.map(function (k) { return self._walkDropEntry(k, path + '/' + k.name, out, failed); })).then(resolve);
                        return;
                    }
                    kids = kids.concat(Array.prototype.slice.call(batch));
                    readBatch();
                }, function () { failed.n++; resolve(); });
            };
            readBatch();
        });
    };

    App.prototype.pickFiles = function () {
        var self = this;
        var input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.addEventListener('change', function () {
            self._addEntries(Array.from(input.files || []).map(function (f) {
                return { path: '/' + f.name, file: f };
            }), 'files_button');
        });
        input.click();
    };

    App.prototype.pickBoot = function () {
        var self = this;
        var input = document.createElement('input');
        input.type = 'file';
        input.addEventListener('change', function () {
            self.bootImage = (input.files && input.files[0]) || null;
            if (self.bootImage && self.dom.bootInfo) {
                self.dom.bootInfo.textContent = self.bootImage.name + ' (' + _human(self.bootImage.size) + ')';
            }
            self._renderSummary();
        });
        input.click();
    };

    App.prototype._renderList = function () {
        if (!this.dom.list) return;
        if (!this.entries.length) { this.dom.list.innerHTML = ''; this._renderSummary(); return; }
        // The list is rendered SORTED while `entries` keeps insertion order, so a
        // row's × must carry the index into `entries` — not its position in the
        // sorted view. It used to carry the sorted position and removed a
        // different file than the one clicked (measured: clicking alpha.bin's row
        // deleted zeta.txt). Remove by PATH: an index into an array that the
        // handler itself mutates is the same trap one step removed.
        var html = '<ul class="icr-entry-list">';
        var sorted = this.entries.slice().sort(function (a, b) { return a.path < b.path ? -1 : 1; });
        sorted.forEach(function (e) {
            html += '<li><span class="icr-path">' + _esc(e.path) + '</span> <span class="icr-size">' + _human(e.file.size) +
                '</span> <button data-rm-path="' + _esc(e.path) + '" class="lg-btn lg-btn-sm" aria-label="' + _esc(e.path) + '">×</button></li>';
        });
        html += '</ul>';
        this.dom.list.innerHTML = html;
        var self = this;
        this.dom.list.querySelectorAll('button[data-rm-path]').forEach(function (b) {
            b.addEventListener('click', function () {
                var path = b.getAttribute('data-rm-path');
                self.entries = self.entries.filter(function (e) { return e.path !== path; });
                self._renderList();
            });
        });
        this._renderSummary();
    };

    App.prototype._renderSummary = function () {
        if (!this.dom.summary) return;
        var totalBytes = this.entries.reduce(function (s, e) { return s + (e.file.size || 0); }, 0);
        var self = this;
        this.dom.summary.innerHTML =
            '<div><b>' + t('files_count', 'Files') + ':</b> ' + this.entries.length + '</div>' +
            (this.entries.length ? '<div><b>' + t('estimated_size', 'Estimated size') + ':</b> <span class="icr-size-val">…</span></div>' : '') +
            '<div><b>' + t('total_data', 'Data') + ':</b> ' + _human(totalBytes) + '</div>';
        // The size the writer WILL produce: its own layout pass on the current
        // list, not a formula beside it (the formula said 662 KB for a 548 KB
        // image). It is arithmetic on names and sizes — no bytes are read — but
        // 15 000 files take ~0.3 s, so it runs once the adding has settled.
        clearTimeout(this._sizeTimer);
        if (!this.entries.length) return;
        this._sizeTimer = setTimeout(function () {
            var el = self.dom.summary.querySelector('.icr-size-val');
            if (!el) return;
            var size = null;
            try { size = self._builder().builder._plan().L.total * 2048; } catch (_) { size = null; }
            el.textContent = size != null ? _human(size) : '—';
        }, 250);
    };

    /* One place that turns the list and the options into a writer — the size in
     * the summary and the image on disk come from the same builder. */
    App.prototype._builder = function () {
        var self = this;
        var o = {
            volumeId: (self.dom.volumeId && self.dom.volumeId.value) || 'TIMBRICA_ISO',
            publisher: (self.dom.publisher && self.dom.publisher.value) || '',
            joliet: !self.dom.toggleJoliet || self.dom.toggleJoliet.checked !== false,
            udf: !self.dom.toggleUdf || self.dom.toggleUdf.checked !== false,
            hybridMbr: !!(self.dom.toggleHybrid && self.dom.toggleHybrid.checked) && !!self.bootImage
        };
        var b = new DI.IsoBuilder(o);
        var dirSet = new Set();
        self.entries.forEach(function (e) {
            var parts = e.path.split('/');
            for (var i = 1; i < parts.length - 1; i++) dirSet.add(parts.slice(0, i + 1).join('/'));
        });
        Array.from(dirSet).sort().forEach(function (p) { b.addDir(p); });
        self.entries.forEach(function (e) { b.addFile(e.path, e.file); });
        if (self.bootImage) b.setBootImage(self.bootImage, { platform: 'BIOS', emulation: 'no-emul' });
        return { builder: b, opts: o, dirs: dirSet.size };
    };

    App.prototype._note = function (html) {
        if (!this.dom.note) return;
        this.dom.note.innerHTML = html;
        this.dom.note.hidden = !html;
    };

    App.prototype.build = function () {
        var self = this;
        if (!self.entries.length) { toast(t('no_files', 'Pick files first'), 'warning'); return; }
        if (!DI.IsoBuilder) { toast('Builder not loaded', 'error'); return; }
        var made = self._builder(), b = made.builder;
        var joliet = made.opts.joliet, udf = made.opts.udf, hybrid = made.opts.hybridMbr;

        var t0 = Date.now();
        var totalBytes = self.entries.reduce(function (s, e) { return s + e.file.size; }, 0);
        var over4g = self.entries.filter(function (e) { return e.file.size > 0xFFFFF800; }).length;
        ae('feature_use', { slug: 'iso-creator', action: 'iso_create_start', file_count: self.entries.length, dir_count: made.dirs, over4g: over4g, total_bytes_mb: Math.round(totalBytes / 1024 / 1024), bootable: !!self.bootImage, hybrid: hybrid, joliet: joliet, udf: udf });
        self._note('');

        // Ask for the destination BEFORE building. showSaveFilePicker() requires
        // transient user activation, and the activation from this click does not
        // survive the build — so asking afterwards silently degraded every real
        // run to the anchor download (and a plain "cancel" surfaced as an error
        // toast, because the AbortError was rethrown into the failure path).
        // Picking first also means a cancel costs no work at all.
        var built = null;
        self._pickDestination().then(function (dest) {
            if (dest === null) {         // cancelled: nothing to say, nothing to clean
                ae('feature_use', { slug: 'iso-creator', action: 'iso_create_cancelled_picker' });
                return null;
            }
            self._showProgress(t('building', 'Building…'));
            return b.build().then(function (out) {
                built = out;
                return self._write(out, dest);
            });
        }).then(function (savedSize) {
            self._hideProgress();
            if (savedSize == null) return;
            var renamed = built ? self._renamedShown(built, udf, joliet) : [];
            ae('feature_use', { slug: 'iso-creator', action: 'iso_create_done', output_size_mb: Math.round(savedSize / 1024 / 1024), ms: Date.now() - t0, fs_layers: built ? built.fs : null, renamed: renamed.length, bootable: !!self.bootImage });
            toast(t('iso_created', 'ISO created') + ' (' + _human(savedSize) + ')', 'success');
            if (renamed.length) self._showRenamed(renamed);
        }).catch(function (err) {
            self._hideProgress();
            // A stale File handle is the one failure this tool sees in practice
            // (a folder picked minutes ago, then moved or unmounted). The browser's
            // own sentence tells the user nothing actionable.
            if (w.ToolErrors && w.ToolErrors.isFileLostError && w.ToolErrors.isFileLostError(err)) {
                toast(t('file_lost_at_select', 'Could not read the file. Please select it again.'), 'error');
                ae('feature_use', { slug: 'iso-creator', action: 'iso_create_file_lost' });
                return;
            }
            handleErr(err, 'iso_create');
            ae('feature_use', { slug: 'iso-creator', action: 'iso_create_failed', reason: String((err && err.message) || err).slice(0, 60) });
        });
    };

    /* The names a reader of THIS image will see differently from the source:
     * UDF's when UDF is on (Windows, macOS and Linux read it first), else
     * Joliet's. Joliet shortening under a UDF image only affects players that
     * cannot read UDF, and saying «renamed» about names nobody on a computer
     * sees would be noise. */
    App.prototype._renamedShown = function (out, udf, joliet) {
        var key = udf ? 'udf' : (joliet ? 'joliet' : null);
        if (!key) return [];
        return (out.renamed || []).filter(function (r) {
            var src = r.path.slice(r.path.lastIndexOf('/') + 1);
            return r[key] != null && r[key] !== src;
        });
    };

    App.prototype._showRenamed = function (list) {
        var first = list[0], src = first.path.slice(first.path.lastIndexOf('/') + 1);
        var shown = first.udf != null ? first.udf : first.joliet;
        var head = fill(t('renamed_note', ':n names were changed so that every system can open them — for example «:from» → «:to».'),
            { n: list.length, from: _esc(src), to: _esc(shown) });
        var items = list.slice(0, 50).map(function (r) {
            return '<li><span class="icr-path">' + _esc(r.path) + '</span> → ' + _esc(r.udf != null ? r.udf : r.joliet) + '</li>';
        }).join('');
        this._note('<div>' + head + '</div>' + (list.length > 1 ? '<details><summary>' + _esc(t('renamed_list', 'Show the list')) + '</summary><ul class="icr-entry-list">' + items + '</ul></details>' : ''));
    };

    App.prototype._outputName = function () {
        return ((this.dom.volumeId && this.dom.volumeId.value) || 'image').toLowerCase().replace(/\s+/g, '-') + '.iso';
    };

    /**
     * → a FileSystemFileHandle (stream straight to disk), 'download' (no FSA in
     * this browser, or the picker refused), or null when the user cancelled.
     */
    App.prototype._pickDestination = function () {
        var name = this._outputName();
        if (!('showSaveFilePicker' in w)) return Promise.resolve('download');
        return w.showSaveFilePicker({
            suggestedName: name,
            types: [{ description: 'ISO image', accept: { 'application/x-iso9660-image': ['.iso'] } }]
        }).then(function (fh) { return fh; }, function (err) {
            if (err && err.name === 'AbortError') return null;   // user said no
            return 'download';                                    // blocked/unsupported
        });
    };

    App.prototype._write = function (out, dest) {
        var self = this;
        var name = this._outputName();
        if (dest === 'download') {
            // The shared primitive: it is the only channel that reports real
            // delivery and the only one that works in an Android WebView.
            if (typeof w.__downloadFile === 'function') {
                return Promise.resolve(w.__downloadFile(out.blob, name)).then(function () { return out.size; });
            }
            var url = URL.createObjectURL(out.blob);
            var a = document.createElement('a');
            a.href = url; a.download = name;
            document.body.appendChild(a); a.click();
            setTimeout(function () { try { document.body.removeChild(a); } catch (_) {} URL.revokeObjectURL(url); }, 8000);
            return Promise.resolve(out.size);
        }
        return dest.createWritable().then(function (writable) {
            return writable.write(out.blob)
                .then(function () { return writable.close(); })
                .then(function () { if (window.__deliveredToDisk) window.__deliveredToDisk(dest.name, out.size, 'save_handle'); return out.size; }, function (err) {
                    // Yandex Browser's protection refuses a direct write of an .iso
                    // to the chosen folder («Blocked by Safe Browsing», 29 sessions
                    // in 90 days — each one ended with nothing). The same image
                    // still goes through the browser's download, which asks the
                    // user instead of refusing outright.
                    if (!/safe browsing/i.test(String((err && err.message) || ''))) throw err;
                    try { writable.abort(); } catch (_) {}
                    ae('feature_use', { slug: 'iso-creator', action: 'iso_create_sb_fallback' });
                    toast(t('sb_downloaded', 'The browser would not let the image be written to that folder, so it is being downloaded instead.'), 'warning');
                    return self._write(out, 'download');
                });
        });
    };

    App.prototype._showProgress = function (txt) {
        if (this.dom.progress) this.dom.progress.style.display = '';
        if (this.dom.progressText) this.dom.progressText.textContent = txt || '';
    };
    App.prototype._hideProgress = function () { if (this.dom.progress) this.dom.progress.style.display = 'none'; };

    function _esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    w.__IsoCreator = { App: App };

    document.addEventListener('DOMContentLoaded', function () {
        var root = document.querySelector('.icr-root');
        if (!root) return;
        var app = new App(root);
        app.boot();
        w.__IsoCreatorApp = app;
        // (No Timbrica3D.init: that is the 3D-printing core and a no-op here —
        // telemetry comes from telemetry-tier0.js plus the __ae calls above.)
    });
})(window);
